"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireDefault(require("react")),
    _DraggableModal = require("./DraggableModal"),
    _DraggableModalProvider = require("./DraggableModalProvider");

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    "default": a
  };
}

var _default = function _default(a) {
  return _react["default"].createElement(_DraggableModalProvider.DraggableModalProvider, null, _react["default"].createElement(_DraggableModal.DraggableModal, a));
};
/* const Modal = require('./DraggableModal')
const Provider = require('./DraggableModalProvider')
export default {
DraggableModal: Modal.DraggableModal,
DraggableModalProvider: Provider.DraggableModalProvider,
}
*/


exports["default"] = _default;